import {Component, Input, OnInit} from '@angular/core';
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {DialogComponent} from "../../../../../../ng2-bootstrap-modal/dialog.component";
import {UserSubscription} from "../../../../../user/user-subscription";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {
  NotificationDialogComponent
} from "../../../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {Utils} from "../../../../../shared/utils/utils";
import {UserService} from "../../../../../user/user.service";
import { filter, first } from 'rxjs';
import {Config} from "../../../../../config/config";
import {Router} from "@angular/router";

@Component({
    selector: 'db-switch-annual-dialog',
    templateUrl: './switch-annual-dialog.component.html',
    styleUrls: ['./switch-annual-dialog.component.scss'],
    standalone: false
})
export class SwitchAnnualDialogComponent extends DialogComponent<null, Boolean> implements OnInit {

  @Input() annualPrice: number;
  @Input() userSubscription: UserSubscription;

  public isMobile: boolean;
  public loading: boolean = false;

  constructor(
    private readonly _dialogService: DialogService,
    private readonly _userService: UserService,
    private readonly _router: Router,
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
  }

  public confirm(): void {
    this.loading = true;
    for (const key of Config.paypalLocalKeys) {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
      }
    }
    this._userService.switchToAnnual()
    .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response: DbResponse): void => {
          if (response.success) {
            if (this.userSubscription && this.userSubscription.paymentType === 'paypal' && response.data && response.data.result.approval_link) {
              localStorage.setItem('dbFromPeriodCycleChange', '1');
              window.location.replace(response.data.result.approval_link);
            } else {
              this._showCycleChangedSuccess(this.annualPrice);
            }
            this.close();
            this._router.navigate(['/websites']);
          }
        });
  }


  private _showCycleChangedSuccess(annualPrice): void {
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: 'Billing cycle changed successfully',
      message: TextUtils.getText('text_switchToAnnualSuccessDesc', {
        date: Utils.formatDate(this.userSubscription.nextBillingDate, 'dd MMM, y'),
        price: annualPrice
      }),
      width: 700,
      buttonText: 'Got It',
      buttonColor: 'black',
      buttonAlign: 'right',
      hasCloseButton: true,
      hasGradientBorder: true,
      textAlign: 'left'
    });
  }

}
